module.exports = __webpack_public_path__ + "img/meat-min.dba0729e.png";